<mat-toolbar color="primary">

  <button mat-icon-button (click)="toggleCollapsed()" *ngIf="allowSidenavAccess">
    <mat-icon>menu</mat-icon>
  </button>
  <a mat-button routerLink=".">
    <img src="/assets/images/icon.png" width="30" height="30">
    Minha Coop</a>

  <span class="menu-spacer"></span>

  <mat-chip-list ng-if="!loggedUser">
    <mat-chip color="primary" selected>{{ loggedUser?.name }}
    </mat-chip>
  </mat-chip-list>
  <img [class]="loggedUser?.image ? 'profile-picture' : 'default-avatar'"
    [src]="loggedUser?.image ?? (authUser.isAssociate ? 'assets/images/default-associate.png' : 'assets/images/default-admin.png')"
    [matMenuTriggerFor]="menu">
  <mat-icon *ngIf="notificationCount > 0" class="notification-dot">notifications_active</mat-icon>
  <mat-menu #menu="matMenu">
    <a mat-menu-item routerLink="/settings/profile">
      <mat-icon>account_circle</mat-icon>
      <span>Meu perfil</span>
    </a>
    <a mat-menu-item routerLink="/settings/notifications">
      <span style="margin-right: 16px;">
        <mat-icon style="margin: 0px">notifications</mat-icon>
        <span [matBadge]="notificationCount" matBadgeColor="primary" matBadgeSize="small"
          [matBadgeHidden]="notificationCount <= 0"></span>
      </span>
      <span>Notificações</span>
    </a>
    <a mat-menu-item routerLink="/messaging" *ngIf="allowMessagesAccess">
      <mat-icon>forum</mat-icon>
      <span>Mensagens</span>
    </a>
    <button mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Sair</span>
    </button>
  </mat-menu>
</mat-toolbar>
<mat-sidenav-container fullscreen autosize class="container">
  <mat-sidenav #sidenav mode="side" [opened]="allowSidenavAccess" disableClose class="sidenav" [class.collapsed]="collapsed">
    <nav class="nav">
      <a class="nav-user" routerLink="/settings/profile" matTooltip="Meu perfil" matTooltipPosition="right"
        [matTooltipDisabled]="!collapsed">
        <img [src]="loggedUser?.image ?? (authUser?.isAssociate ? 'assets/images/default-associate.png' : 'assets/images/default-admin.png')"
          alt="">
        <span class="nav-user-name">{{ loggedUser?.name }}</span>
      </a>

      <label class="nav-search" (click)="expandToSearch(searchInput)">
        <mat-icon>search</mat-icon>
        <input #searchInput type="text" placeholder="Pesquisar no menu" autocomplete="off" [(ngModel)]="search"
          (keydown.escape)="search = ''">
      </label>

      <ng-container *ngFor="let sidenavParent of filteredParents; trackBy: trackByTitle">
        <span class="nav-section-title">{{ sidenavParent.title }}</span>
        <button type="button" *ngFor="let item of sidenavParent.items; trackBy: trackByTitle" class="nav-item" [class.active]="isActive(item)"
          (click)="navigate(item)" [matTooltip]="item.title" matTooltipPosition="right" [matTooltipDisabled]="!collapsed">
          <mat-icon fontSet="material-icons-outlined">{{ item.icon }}</mat-icon>
          <span>{{ item.title }}</span>
        </button>
      </ng-container>

      <span class="nav-empty" *ngIf="filteredParents.length == 0">Nenhum item encontrado</span>
    </nav>

    <button type="button" class="nav-item nav-collapse" (click)="toggleCollapsed()"
      [matTooltip]="collapsed ? 'Expandir menu' : ''" matTooltipPosition="right" [matTooltipDisabled]="!collapsed">
      <mat-icon>{{ collapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
      <span>Recolher menu</span>
    </button>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
